import * as api from '@/api/stufdback'
import cookie from 'js-cookie'
import { stufdback } from '@/store/mutation-type'

const state = {
    info: {},
    helpfdbackList: []
}

const getters = {
    [stufdback.FDBA_LIST]: (state) => {
        return state.helpfdbackList[state.info['APP']]
    }
}

const actions = {
    [stufdback.CLIENT_INFO]: ({ commit }) => {
        commit(stufdback.CLIENT_INFO, cookie.get())
    },
    [stufdback.FDBACK_LIST]: ({ commit }) => {
        api.helpFdbackData({}, (_data) => commit(stufdback.FDBACK_LISTS, _data))
    }
}

const mutations = {
    [stufdback.FDBACK_LISTS]: function (state, _data) {
        console.log('FDBACK_LISTS')
        console.log(_data)
        state.helpfdbackList = _data
        // console.log(_data)
    },
    [stufdback.CLIENT_INFO]: function (state, _data) {
        state.info = _data
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/stufdback.js